import React from 'react';
import { Stack, Dialog } from '@mui/material';
import BgImage from 'components/home/bgimage';
import HomePageMain from './main-title';
import TextOnImage from './text-on-image';
import CardOnHome from './card-on-home';
import Products from './products';
import Bullets from './bullets';
import ContactPopUp from 'components/contact-popup';
import { useDispatch, useSelector } from 'react-redux';
import { setContactUs } from 'api/session';
import Block1a from './block1a';
import Block4 from './block4';
import Block5 from './block5';
import Block6 from './block6';
import Block7 from './block7';

const HomeIndex = (children) => {

    const dispatch = useDispatch();

    const contactUs = useSelector(state => state.session.contactUs);
    return (
        <React.Fragment>
            <Stack

                direction="column"
                spacing={3}
                alignItems="center"
                justifyContent={'center'}
                sx={{
                    backgroundColor: "#fff",
                    marginTop: { xs: "180px", sm: "106px", md: "152px" },
                }}
            >
                <BgImage />


            </Stack>
            {/* <HomePageMain/> */}
            <TextOnImage />
            <Block1a />
            <Block4 />
            <Block6 />
            <Block7 />
            <Block5 />


            <CardOnHome />

            <Bullets />
            {/* <Products /> */}

            <Dialog anchor={"top"} open={contactUs} onClose={() => dispatch(setContactUs(false))}>
                <ContactPopUp />
            </Dialog>

        </React.Fragment>
    )
}

export default HomeIndex;